module.exports = __webpack_public_path__ + "static/media/LidlPro_Italic.b44ebff9.woff2";